module.exports = __webpack_public_path__ + "img/autorizado-icon.2e1a2bc.svg";